import { LiveStreamActivePlaylist } from '@clipr/lib'

export const getJobLiveStreamPlaylistLabel = (value: LiveStreamActivePlaylist) => {
  if (value === LiveStreamActivePlaylist.Secondary)
    return 'Backup';

  return value;
}